import { useEffect, useState } from "react";

// Single breakpoint keyed to the Jobs app's 2-col grids collapsing cleanly
// (max-width 767px, the same line responsive.css uses). Reads matchMedia (the
// CSS layout viewport) rather than window.innerWidth, which is not guaranteed
// to equal the rendered width (emulated or zoomed viewports).
export function useIsMobile(breakpoint = 768) {
  const query = `(max-width: ${breakpoint - 1}px)`;
  const [isMobile, setIsMobile] = useState(() => typeof window !== "undefined" && window.matchMedia(query).matches);
  useEffect(() => {
    if (typeof window === "undefined") return undefined;
    const mql = window.matchMedia(query);
    const onChange = () => setIsMobile(mql.matches);
    onChange();
    mql.addEventListener("change", onChange);
    return () => mql.removeEventListener("change", onChange);
  }, [query]);
  return isMobile;
}
